import { feathersClient, makeServicePlugin, BaseModel } from "@/api/feathers-client"; 

class FullUserInformation extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'FullUserInformation'
  // Define default properties here
  static instanceDefaults() {
    return {}
  }
}

const servicePath = '/api/call-control/user-profile-information'
const servicePlugin = makeServicePlugin({
  Model: FullUserInformation,
  service: feathersClient.service(servicePath),
  servicePath: 'user-profile-information'
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [ async (context) => {
      context.result = {
        id: context.result.id,
        ...context.result.result
      };
      return context;
    } ],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin